// Components/ui
import {
  InformationItemContainer,
  InformationItemInputsContainer,
  NoteDeleteButton,
} from '../../../../../../shared';
import { Typography } from '@mui/material';
import imsStyle from './style';
// Types
import { NewAddress } from '../../../../../../../../../../../utils/contactHelper';
import UseEditBusiness from '../../../../../../../../../../../hooks/useEditBusiness/types/UseEditBusiness';
import UseEditContact from '../../../../../../../../../../../hooks/useEditContact/types/UseEditContact';
import { IContactAddress } from '@trii/types/dist/Contacts';

type Props = {
  data: NewAddress | IContactAddress;
  editEntity: UseEditBusiness | UseEditContact;
};

const Ims = ({ data, editEntity }: Props) => {
  const editActions = editEntity.action;

  return (
    <InformationItemContainer>
      <InformationItemInputsContainer>
        <Typography sx={imsStyle.code} variant="body2">
          {data.address}
        </Typography>
        <NoteDeleteButton
          addressData={data}
          handleNoteFieldChange={editActions.handleNoteFieldChange}
          handleDeleteAddress={editActions.handleDeleteAddress}
        />
      </InformationItemInputsContainer>
    </InformationItemContainer>
  );
};

export default Ims;
